import { formatDateByTimezone } from '../../app/helpers/date'

/**
 * TasksCtrl controller
 * Show all System Tasks
 */

/**
 * AddPushNotificationCtrl controller
 *
 * @class AddPushNotificationCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddPushNotificationCtrl
 */
/* @ngInject */
export default function AddPushNotificationCtrl ($uibModalInstance, $uibModal, $scope, PushNotification, subscriptions, pn, pckg, isCopy) {
  var vm = this

  /**
   * PushNotification
   *
   * @memberof mwApp/packages.controller:AddPushNotificationCtrl
   * @type {models.Announcement}
   */
  vm.pn = pn
  vm.pn.$isCopy = isCopy
  vm.loaded = false

  vm.contentloading = false

  /**
   * Resource types
   *
   * @memberof mwApp/packages.controller:AddPushNotificationCtrl
   * @type {Object}
   */
  vm.resourceTypes = {
    INTERNAL: 'Content Link',
    WITHOUT_LINK: 'Without Link'
  }

  vm.publishTypes = {
    NOW: 'Now',
    SCHEDULED: 'Scheduled sending'
  }

  vm.pn.$contentTypes = [
    { value: 'VOD', name: 'Movies' },
    { value: 'TV_CHANNEL', name: 'TV Channels' },
    { value: 'TV_SHOW', name: 'TV Shows' }
  ]

  /**
   * isNew flag
   *
   * @memberof mwApp/packages.controller:AddPushNotificationCtrl
   * @type {Boolean}
   */
  vm.isNew = pn._isNew()
  vm.subscriptions = subscriptions
  vm.pn.$subscription = vm.subscriptions ? vm.subscriptions.find(sub => sub.id === vm.pn.subscriptionId) : null

  if (vm.isNew) {
    vm.pn.resourceType = 'INTERNAL'
    vm.pn.scheduleType = 'NOW'
    vm.pn.$startDate = new Date()
    vm.pn.$startTime = new Date()
    vm.pn.$contentType = { value: 'TV_CHANNEL', name: 'TV Channels' }
  } else {
    vm.pn.$contentType = vm.pn.$contentTypes.filter(ct => ct.value === vm.pn.contentType)[0]
    if (isCopy) {
      vm.pn.id = null
      vm.pn.status = null
      vm.pn.createdBy = null
      vm.pn.updatedBy = null
      vm.pn.createdTime = null
      vm.pn.updatedTime = null
      vm.pn.contentEnabled = true
      vm.pn.contentUnassignedOrDeleted = false
    }
  }
  vm.disabledByStatus = ['SENT_OUT', 'DELETED'].includes(vm.pn.status)

  PushNotification.loadExtra({ networkId: pckg.id })
    .then((data) => {
      vm.pn.$contentTypes = vm.pn.$contentTypes.filter(prop => data.contentTypes.includes(prop.value))
      vm.pn.$platforms = pn._enhancePlatforms(data.platformTypes).filter((platform) => data.platformTypes.includes(platform.name.toUpperCase()))
      vm.pn.$subscriberStatuses = pn._enhanceStatuses(data.subscriberStatuses).filter((status) => data.subscriberStatuses.includes(status.value.toUpperCase()))
      vm.subscriptions = data.subscriptions
      vm.pn.$subscription = vm.subscriptions ? vm.subscriptions.find(sub => sub.id === vm.pn.subscriptionId) : null
      vm.loaded = true
    })

  /**
   * Check, if at least one subscribers status group
   *
   * @return {Boolean}
   */
  vm.atLeastOneSubscribersStatusGroup = function () {
    for (let i = vm.pn.$subscriberStatuses.length; i--;) {
      if (vm.pn.$subscriberStatuses[i].checked) {
        return true
      }
    }
    return false
  }

  /**
   * Check, if at least one platform is selected
   *
   * @return {Boolean}
   */
  vm.atLeastOnePlatform = function () {
    for (let i = vm.pn.$platforms.length; i--;) {
      if (vm.pn.$platforms[i].checked) {
        return true
      }
    }
    return false
  }

  /**
   * Datepicker settings
   *
   * @memberof mwApp/packages.controller:AddPushNotificationCtrl
   * @type {Object}
   */
  vm.dpCfg = {
    format: 'dd.MM.yyyy',
    minDate: new Date(),
    changeHandler: function (field, form) {
      field.$setTouched()
      if (form.timeFrom.$valid) {
        const fromDate = vm.pn.$startDate && vm.pn.$startDate.setHours(vm.pn.$startTime.getHours(), vm.pn.$startTime.getMinutes())
        const dateNow = formatDateByTimezone(Date.now(), false).valueOf()
        const minDateStart = fromDate > dateNow
        field.$setValidity('earlier', minDateStart)
      }
    }
  }

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/packages.controller:AddPushNotificationCtrl
   */
  vm.open = function () {
    vm.dpCfg.opened = true
  }

  /**
   * Search users params with default values
   *
   * @memberof mwApp/reports.controller:AddSubscribersReportCtrl
   * @type {Object}
   */
  vm.searchContentParams = {
    q: '',
    networkId: pckg.id,
    page: 0,
    last: false
  }

  /**
   * Filter subscriptions, it seems that this works faster, then filter in ui-select-choices
   *
   * @memberof mwApp/shows.controller:AddUsersReportCtrl
   * @param  {Object} $select
   */
  vm.$timerSubscriptions = 0
  vm.openCountSubscriptions = 0
  vm.refreshContent = function ($select = {}) {
    let search = $select.search || ''

    vm.searchContentParams.page = 0

    search = search ? search.toLowerCase() : ''
    vm.openCountContent = $select.open
      ? vm.openCountContent + 1
      : 0

    if (vm.openCountContent > 1) {
      vm.searchContentParams.q = $select.search
    }

    if (vm.openCountContent === 1) {
      $select.search = vm.searchContentParams.q
    }

    if ($select.open) {
      vm.contentloading = true
      window.clearTimeout(vm.$timerContent)
      vm.$timerContent = window.setTimeout(() => {
        PushNotification.search(
          `api/networks/${pckg.id}/push-notifications/extra/subscriptions/${vm.pn.$subscription.id}/content`,
          {
            q: search,
            page: 0,
            networkId: pckg.id,
            contentType: 'TV_CHANNEL'
          }
        )
          .then((result) => {
            vm.searchContentParams.last = result.last
            vm.contentList = result.content
          })
          .finally(() => { vm.contentloading = false })
      }, 700)
    }
  }

  /**
   * Handler for scroll event of select list
   *
   * @param event
   */
  vm.$timerContentScroll = 0
  vm.contentCallbackScroll = (event) => {
    const { last } = vm.searchContentParams
    if (!last && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      vm.contentloading = true
      window.clearTimeout(vm.$timerContentScroll)
      vm.$timerContentScroll = window.setTimeout(() => {
        vm.searchContentParams.page++
        PushNotification.search(
          `api/networks/${pckg.id}/push-notifications/extra/subscriptions/${vm.pn.$subscription.id}/content`,
          { ...vm.searchContentParams, contentType: 'TV_CHANNEL' }
        )
          .then((result) => {
            vm.contentList = vm.contentList.concat(result.content)
            vm.searchContentParams.last = result.last
          })
          .finally(() => { vm.contentloading = false })
      }, 700)
    }
  }

  /**
   * Create or edit pushNotification, and close modal window afterwards
   *
   * @memberof mwApp/packages.controller:AddPushNotificationCtrl
   */
  vm.submit = function (form) {
    if (form.startDate) { vm.dpCfg.changeHandler(form.startDate, form) }
    if (form.$invalid) { return }

    vm.pn.networkId = pckg.id
    vm.setDisable()
    pn._save()
      .then(() => $uibModalInstance.close(pn))
      .finally(vm.unsetDisable)
  }

  vm.delete = function () {
    pn._delete()
      .then(() => $uibModalInstance.close(pn))
      .finally(vm.unsetDisable)
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/packages.controller:AddPushNotificationCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
